import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { DemandPageModel, demandPageModel } from './model'; 
import { ctrl  } from './controller'; 
import SiteBreadcrumb from '@/components/SiteBreadcrumb';
import './index.less';  
import { useNavigate } from 'react-router-dom';
import { globalStore } from '@/common';
import LoadingPlaceholder from '@/components/LoadingPlaceholder';
import { Card } from 'antd';
import Filter from './parts/Filter';
import List from './parts/List';
import AddEdit from './parts/AddEdit';

const View: React.FC = observer(() => {

  useEffect(() => {
     ctrl.initialize();
  }, []);

  const navigate = useNavigate();

  if (globalStore.sessionChecked && !globalStore.isLogin) {
    navigate('/login');
  }

  if ( !globalStore.isLoaded || !demandPageModel.isLoaded) {
    return <LoadingPlaceholder />;
  }
 
 
  return (
    <div className='demand-page'> 
        <SiteBreadcrumb name="需求管理" />
        <Card>
          <Filter currentUser={globalStore.currentUser} model={demandPageModel}></Filter>
          <List  list={demandPageModel.filteredList}></List>
        </Card>
    </div> 
  );
});
/**
 提示词：

帮我写一个需求管理页面，项目使用react+ant-d 4.2，布局代码写好了(在view.tsx文件内)如下
```
 const currentUser:User = store.user;
 
  return (
    <div> 
        <SiteBreadcrumb name="需求管理" />
        <Card>
          <Filter model={demandPageModel}></Filter>
          <List  list={demandPageModel.demandList}></List>
        </Card>
    </div> 
  );
```
所使用到的数据结构对象如下
```
export class User{
    brief: string
    id: number
    phone: string
    userAvatar:string
    userName:string
    userNamePinyin:string
}


export class Comment{
    id:number;
    content:string;
    fromUserId:number;
    fromUserName:string;
    toUserid:number;
    toUserName:string;
    replyToId:number
    createTime:Date;
    updateTime:Date;
}

export class OperationLog{
    id:number;
    operatorId:number;
    operatorName:string;
    content:string;
    logTime:Date;
}


export interface Demand{

    content:string
    submitterId:number
    submitterName:string
    executorId:number
    executorName:string
    submitTime:Date
    status:number
    comment:Comment[]
    logs:OperationLog[]

}

export interface FilterOptions{
    submitterId: number
    status:number[]//允许的状态，当为null时，指所有状态
}

export interface SortOptions{
    bySubmitTime:boolean;
    bySubmitter:boolean;
    byExecutor:boolean;
    byStatus:boolean;
    order:'asc' | 'desc';
}

export class DemandPageModel{
    filterOptions:FilterOptions; 
    demandList : Demand[];
    sortOptions: SortOptions;
    constructor() {
        makeAutoObservable(this);
    }
}

export const model = new DemandPageModel();

```

要求帮我实现Filter 和 List组件，分别写到Filter.tsx中和 List.tsx中，样式文件分别为 Filter.less和List.less

Filter组件分为2大行
第一行是筛选行，从左开始第一个元素是一个 筛选ICON，代表该行的用途是筛选。支持筛选的条件有：
1、只看待立项（筛选特定状态的需求，它是一个勾选按钮，勾选时筛选生效，取消勾选时筛选条件去除）
2、只看已立项（筛选特定状态的需求，与上同理）
3、只看已废弃（筛选特定状态的需求，与上同理）
4、只看自己提报（筛选出自己提报的需求，勾选效果同理），也就是提交人为当前登录用户ID
第一行的最右边（靠右对齐）的元素是一个【添加需求】的按钮，点击后是一个创建需求的面板（暂时不要实现）
第二行是排序行，从左开始的第一个元素是一个 排序ICON，代表该行的用途是排序。支持的排序条件有：
1、 提出时间
2、 提出人
3、 负责人
4、 状态
要求每个条件点击后右边出现一个排序的三角ICON，代表排序的方向，向下为倒序，向上为正序。
第二行的最右边（靠右对齐）的元素有3个，分别是：
1、列表记录条数，显示为“共X条”，X为条数
2、无边框的按钮：折叠。点击后列表项全部折叠起来。
3、无边框的按钮：刷新。点击后调用API，刷新数据。

List组件要求使用Ant-D的Collapse组件

每个列表项目独占一行，内容垂直居中。折叠时高度80，只显示需求简要信息，展开时按照展开区大小决定高度。
列表项目折叠时的行内容分为两块分别靠左和靠右——
靠左的元素从左到右有：
1、需求编号：固定宽度50px
2、需求描述（宽度超过400时隐藏，超出部分显示为...）
3、需求状态（一个标签样式展示，不同状态颜色不一样）

靠右的元素从左到右有：
1、需求提报人员头像（请使用ToolTip组件让鼠标移动上去时能提示人员姓名）
2、负责人头像（请使用ToolTip组件让鼠标移动上去时能提示人员姓名）
3、一个快捷设置需求状态的下拉框，共有三个状态：待处理、已立项 和 已废弃

列表项目展开时，需求简要信息区域不变，下方为需求详情区，需求详情区包含左右2个部分，左边为信息区，右边为评论区，中间用一条线条分开。
信息区是一个小列表，小列表每一条分为左右两部分，左边为示意ICON，右边为具体的内容。小列表共有4行：
1、需求内容
2、提出时间
3、提出人员
4、负责人员

评论区分为上下两块，上面部分为输入框，下面部分为评论展示区，每一条包含 头像、时间和评论内容，评论展示区高度300px，超过了显示滚动条。




要求所有元素尽量采用无边框，所涉及的ICON请自行从Ant-D组件中选取合适的，所有布局采用Ant-D的Space、Row、Col组件

 * 
 */

export default View;
